import {useTheme} from "@emotion/react";
import Markdown from "@/elements/Markdown";
import TitleUnderlinedAnimated from "@/elements/TitleUnderlinedAnimated";
import {Text} from "@/elements/text";
import type {SectionWysiwygOld} from "@/generated/api";
import SectionWrapper from "@/layouts/SectionWrapper";
import {ContentWrapper} from "./styles";

interface B2TexteWYSIWYGProps {
  sectionData: SectionWysiwygOld;
  isFirstSection?: boolean;
  isLastSection?: boolean;
  id?: string;
}

export default function B2TexteWYSIWYG({
  sectionData,
  isFirstSection,
  isLastSection,
  id,
}: B2TexteWYSIWYGProps) {
  const {bg_color, column, subtitle, text1, text2, title} = sectionData;
  const isOneColumn = column === "one-column" || column === "";
  const {breakpoints} = useTheme();
  const {isMobile, md} = breakpoints;
  if ((text1 ? text1.length : 0) === 0 && (text2 ? text2.length : 0) === 0) {
    return null;
  }
  return (
    <SectionWrapper
      id={id}
      backgroundColor={bg_color}
      isFirstSection={isFirstSection}
      isLastSection={isLastSection}
      styles={{
        paddingBlock: "0px 0px",
      }}
    >
      <ContentWrapper>
        {!!title?.length && (
          <TitleUnderlinedAnimated styles={{fontSize: "2rem", lineHeight: "2.5rem"}}>
            {title}
          </TitleUnderlinedAnimated>
        )}

        {!!subtitle?.length && (
          <Text as={"h3"} type="titleExtraSmall" styles={{marginBottom: 12}}>
            {subtitle}
          </Text>
        )}
        {isOneColumn && !!(text1 ? text1.length : 0) && (
          <Markdown
            textStyles={{marginBottom: 27}}
            h3Styles={{marginBottom: 12}}
            wrapperStyles={{marginBottom: 33, marginTop: 38}}
          >
            {text1}
          </Markdown>
        )}
      </ContentWrapper>

      {!isOneColumn && !!(text1 ? text1.length : 0) && !!(text2 ? text2.length : 0) && (
        <>
          <div
            style={{
              gridColumn: isMobile ? "1/-1" : md ? "3/9" : "4/9",
              paddingRight: isMobile ? 0 : 10,
              marginBottom: isMobile ? 20 : 0,
            }}
          >
            <Markdown
              textStyles={{marginBottom: 27}}
              h3Styles={{marginBottom: 12}}
              wrapperStyles={{marginTop: 0, marginBottom: 27}}
            >
              {text1}
            </Markdown>
          </div>
          <div style={{gridColumn: isMobile ? "1/-1" : md ? "9/15" : "9/14"}}>
            <Markdown
              textStyles={{marginBottom: 27}}
              h3Styles={{marginBottom: 12}}
              wrapperStyles={{marginTop: 0, marginBottom: 27}}
            >
              {text2}
            </Markdown>
          </div>
        </>
      )}
    </SectionWrapper>
  );
}
